import React, { useRef, useEffect, useCallback } from "react";
import { ChatFooter, UploadSwingAction, UploadSwingMessage, UploadSwingMessageTypo, UploadSwingTypo } from "../chatStyled";
import { Box } from "@mui/material";

interface ChatBodyFooterProps {
    SwingUploadIcon: React.ReactElement;
    SwingUploadTypo: string;
    SwingUploadMessage: string;
    onLoadFile: (file: File) => void;
    isBlocked?: boolean;
    onBlockedAction?: () => void;
};

const ChatBodyFooter: React.FC<ChatBodyFooterProps> = (props) => {
    const fileInputRef = useRef<HTMLInputElement>(null);

    const handleFileUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (file) {
            props.onLoadFile?.(file);
        }
    };
    
    const handleClick = useCallback(() => {
        if (props.isBlocked) {
            props.onBlockedAction?.();
            return;
        }
        fileInputRef.current?.click();
    }, [props.isBlocked, props.onBlockedAction]);

    // Expose handleClick on window so ConnectAccordion can call it directly
    useEffect(() => {
        console.log('ChatBodyFooter: Exposing handleClick on window');
        (window as any).__chatBodyFooterHandleClick = handleClick;
        return () => {
            delete (window as any).__chatBodyFooterHandleClick;
        };
    }, [handleClick]);
    
    return (
        <ChatFooter>
            <input
                ref={fileInputRef}
                type="file"
                accept="video/*"
                onChange={handleFileUpload}
                style={{ display: 'none' }}
            />
            <UploadSwingAction onClick={handleClick}>
                <Box>
                    {props.SwingUploadIcon}
                </Box>
                <Box>
                    <UploadSwingTypo>
                        {props.SwingUploadTypo}
                    </UploadSwingTypo>
                </Box>
            </UploadSwingAction>
            <UploadSwingMessage>
                <UploadSwingMessageTypo>
                    {props.SwingUploadMessage}
                </UploadSwingMessageTypo>
            </UploadSwingMessage>
        </ChatFooter>
    )
}

export default ChatBodyFooter;